var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","sm":"9"}},[_c('h1',{},[_vm._v("Email verification")]),(_vm.isDone)?_c('v-alert',{staticStyle:{"color":"white"},attrs:{"dense":"","color":"primary"}},[_vm._v(" You've successfully verified your email. ")]):_vm._e(),_c('v-btn',{attrs:{"elevation":"","color":"primary"},on:{"click":function($event){return _vm.$router.push({
        name: 'auth',
        params: {
          authPage: 'login',
        },
      })}}},[_vm._v(" Goto dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }